module.exports = __webpack_public_path__ + "static/media/cv-settings.e1402f39.svg";